import React, { useEffect, useState } from 'react';
import { GridRenderEditCellParams } from '@mui/x-data-grid-pro';
import { Account } from '../../../types';
import { AccountSelectionForm } from '../UserCreation';

interface AccountEditCellProps extends GridRenderEditCellParams {
  // Using a more generic type to accommodate both Community and Pro APIs
  api: GridRenderEditCellParams['api'];
  accounts: Account[];
}

const AccountEditCell: React.FC<AccountEditCellProps> = (props) => {
  const { api, id, value, accounts } = props;

  // Find the account that matches the current customerName value
  const initialAccount = accounts.find((account) => account.name === value) || null;

  const [selectedAccount, setSelectedAccount] = useState<Account | null>(initialAccount);
  const [dirty, setDirty] = useState(false);

  // Update the selected account when the value prop changes
  useEffect(() => {
    const newAccount = accounts.find((account) => account.name === value) || null;
    if (newAccount !== selectedAccount) {
      setSelectedAccount(newAccount);
    }
  }, [value, accounts, selectedAccount]);

  const handleChange = (account: Account | undefined) => {
    if (!dirty) setDirty(true);

    setSelectedAccount(account || null);

    if (account) {
      // Update customerName in the current edit cell
      api.setEditCellValue({ id, field: 'customerName', value: account.name }, undefined);

      // Update the entire row to ensure customerId is set
      const currentRow = api.getRow(id);
      api.updateRows([
        {
          ...currentRow,
          id,
          customerName: account.name,
          customerId: account.id
        }
      ]);
    } else {
      // Clear customer fields
      api.setEditCellValue({ id, field: 'customerName', value: '' }, undefined);

      // Update the entire row to clear customerId
      const currentRow = api.getRow(id);
      api.updateRows([
        {
          ...currentRow,
          id,
          customerName: '',
          customerId: ''
        }
      ]);
    }
  };

  return (
    <div style={{ width: '100%', height: '100%', display: 'flex', alignItems: 'center' }}>
      <AccountSelectionForm
        accounts={accounts}
        selectedAccount={selectedAccount}
        setSelectedAccount={handleChange}
        showLabel={false}
        size="small"
        styles="w-full"
        inputStyles="h-full"
        styleOverride={{
          '& .MuiInputBase-root': {
            height: '100%',
            fontSize: '0.875rem'
          },
          '& .MuiInputBase-input': {
            padding: '8px',
            height: 'auto'
          },
          '& .MuiOutlinedInput-notchedOutline': {
            border: 'none'
          },
          '& .MuiInputLabel-root': {
            display: 'none'
          }
        }}
      />
    </div>
  );
};

export default AccountEditCell;
